//
//
//
//

export default {
  name: 'TheMaskIcon',

  props: {
    name: {
      type: String
    }
  },

  data() {
    return {
      svgHtml: ''
    }
  },

  watch: {
    name: {
      immediate: true,
      handler() {
        this.loadSvg()
      }
    }
  },

  methods: {
    async loadSvg() {
      try {
        const url = require(`@/assets/img/masks/${this.name}.svg`)
        const res = await fetch(url)
        let text = await res.text()
        // Normalize transforms: if maskContentUnits="objectBoundingBox" and transform has negative Y scale,
        // ensure translate(0,1) is applied so content maps into [0,1]
        if (/maskContentUnits="objectBoundingBox"/.test(text)) {
          text = text.replace(/transform="([^"]*?)scale\(([^,\s]+)\s*,\s*(-[^\)\s]+)\)"/g, (m, pre, sx, sy) => {
            if (/translate\(/.test(pre)) return m
            const prefix = pre ? pre.trim() + ' ' : ''
            return `transform="translate(0,1) ${prefix}scale(${sx},${sy})"`
          })
        }
        this.svgHtml = text
      } catch (e) {
        this.svgHtml = ''
      }
    }
  }
}
